import { Button, Icon } from '@lightspeed/design-system-react'
import { UT } from '@transifex/react'
import { trackError, trackUserEvent } from '@vend/utilities'
import React, { FunctionComponent, useState } from 'react'
import { isConfirmedNotReadyToComplete, toJSON } from '../../../functions/sale'
import { SaleSyncStatus } from '../../../models/sale.constants'
import { useSaleManager } from '../../../ng-compat/hooks'
import { useAppSelector } from '../../../state/hooks'
import { selectCurrentSale } from '../../../state/slices/currentSale/currentSaleSlice'
import { WEB_REGISTER } from '../../web-register.constant'
import { DismissableSaleStatus, DismissSaleModal } from './DismissSaleModal'

export interface DismissSaleProps {
  disabled: boolean
}

export const DismissSale: FunctionComponent<DismissSaleProps> = ({
  disabled,
}) => {
  const [isModalOpen, setModalOpen] = useState<boolean>(false)
  const sale = useAppSelector(selectCurrentSale)
  const saleManager = useSaleManager()

  const handleClick = async (): Promise<void> => {
    if (!isConfirmedNotReadyToComplete(sale) && !sale.isSavedUnfulfilled) {
      trackError('[SaleCtrl] Error dismissing sale', {
        data: {
          sale: sale && toJSON(sale),
        },
      })

      return
    }

    trackUserEvent(WEB_REGISTER.DISPLAY_NAME, 'Sale Action Buttons', {
      saleState: sale.displayStatus,
      button: 'Dismiss Sale',
    })

    if (sale.syncStatus === SaleSyncStatus.MODIFIED) {
      setModalOpen(true)

      return
    }

    return saleManager.clearSale()
  }

  const handleModalCancel = () => setModalOpen(false)
  const handleModalConfirm = () => {
    setModalOpen(false)
    saleManager.clearSale()
  }

  return (
    <>
      <Button
        variant="supplementary"
        modifier="text"
        id="pro-sl-btn-dismiss-sale"
        onClick={handleClick}
        disabled={disabled}
        role="button"
      >
        <Icon icon="close" className="vd-mr2" />
        {
          <UT
            _str="Dismiss <span class='wr-hide-on-mobile'>sale</span>"
            _context="Dismiss sale button on the sale actions bar"
            _inline
          />
        }
      </Button>
      {isModalOpen && (
        <DismissSaleModal
          saleStatus={sale.status as DismissableSaleStatus}
          onCancel={handleModalCancel}
          onConfirm={handleModalConfirm}
        />
      )}
    </>
  )
}
